import { createSlice } from "@reduxjs/toolkit";
 
const initialState = {  
    correo_institucional:'',
    user:'',
    rol:'',
    alcance: ''
  };

const userDataSlice = createSlice({
    name:"USERDATA",
    initialState,
    reducers: { 
        setUserDataSlice: (state, action) => { 
            return {
                ...state, 
                user: action.payload.user,
                correo_institucional: action.payload.correo_institucional,
                rol: action.payload.rol,
                alcance: action.payload.alcance,
                adscripcion: action.payload.adscripcion
            };
        },
        clearUserData: (state) =>  initialState
    }
})
export const { setUserDataSlice, clearUserData } = userDataSlice.actions;
export const selectUserDataSlice=(state)=>state;
export default userDataSlice.reducer;